export const SET_DATA_ACTIVE = (state, data) => {
  state.dataActive = data;
}
